import {
    ADDITIONAL_SERVICE_SUPPORTED_UNITS,
    ADDITIONAL_SERVICE_SUPPORTED_UNITS_SCHEMA,
    SUPPORTED_UNITS,
} from '@schuettflix/interfaces';

export function toAdditionalServiceUnit(
    unit: SUPPORTED_UNITS | undefined
): ADDITIONAL_SERVICE_SUPPORTED_UNITS | undefined {
    return ADDITIONAL_SERVICE_SUPPORTED_UNITS_SCHEMA.safeParse(unit).data;
}
